export const TermInputs = [
  { name: 'term', label: "Term", type: 'text', defaultValue: '', validation: { required: "Please enter a term" } },
  { name: 'startDate', label: "Start Date", type: 'date', defaultValue: '', validation: { required: "Please enter a date" } },
  { name: 'endDate', label: "End Date", type: 'date', defaultValue: '', validation: { required: "Please enter a date" } },
];